module.exports = __webpack_public_path__ + "static/media/sprout-app.217dc337.png";